module.exports = __webpack_public_path__ + "static/sec2-bd96b73ba47ee7da6cf114621ab29aba.png";